import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Icon } from '@holmescorp/base-widgets/icon';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import css from '../css/carousel.m.css';
const factory = create({
    theme
}).properties();
export const CarouselNav = factory(({ id, properties, middleware: { theme } }) => {
    const { key, xqa, aria = {}, onClick, onKeyDown, direction = 'left', disabled = false } = properties();
    const themeCss = theme.classes(css);
    const widgetId = `carousel-${direction}-${id}`;
    return v('div', {
        id,
        key,
        widgetId,
        xqa,
        role: 'button',
        ...formatAriaProperties(aria),
        tabIndex: 0,
        disabled: disabled,
        classes: [themeCss.nav, disabled && themeCss.disabled, themeCss[direction], theme.variant()],
        onclick: () => onClick && onClick(),
        onkeydown: (event) => onKeyDown && onKeyDown(event)
    }, [w(Icon, { faname: `chevron-${direction}`, size: 'lg' })]);
});
export default CarouselNav;
